import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import {
	PersonalInformation,
	ContactInformation,
	BusinessInformation,
	EducationalInformation,
	FamilyInformation,
	TravelInformation,
	BankInformation,
	DetailsOfRequest,
	DocumentationGroup,
	FinancialInformation,
} from "../partials/FormFields";
import RequestStatusForm from "../../../components/common/RequestStatusForm";

const SubmittedForm = ({ objectData }) => {
	const [formData, setFormData] = useState(objectData);
	// const [action, setAction] = useState("view");
	// const isEditable = action === "edit";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<div className='RightSection w-full'>
					<FormAccordion title='Personal Information' open={true}>
						<PersonalInformation formData={formData} handleInputChange={handleInputChange} />
					</FormAccordion>

					<FormAccordion title='Contact Information'>
						<ContactInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Professional/ Business Information'>
						<BusinessInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Educational/ Study Information'>
						<EducationalInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Family Information'>
						<FamilyInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Travel Information'>
						<TravelInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Bank Information'>
						<BankInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Details Of Request'>
						<DetailsOfRequest formData={formData} />
					</FormAccordion>

					<FormAccordion title='Financial Information'>
						<FinancialInformation formData={formData} />
					</FormAccordion>

					<FormAccordion title='Documentation'>
						<DocumentationGroup formData={formData} />
					</FormAccordion>

					{/* {formData?.type?.toLowerCase().includes("quick") && ( */}
					<FormAccordion title='Request Status' open={true}>
						<RequestStatusForm
							formData={formData}
							handleInputChange={handleInputChange}
							service='travel-advance'
						/>
					</FormAccordion>
					{/* )} */}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
SubmittedForm.propTypes = {
	objectData: PropTypes.object,
};

export default SubmittedForm;
